<template>
    <div>
        <section class="section p-3" style=" background: #233dff; ">
            <div class="container mb-0 mt-5">
                <div class="row">
                </div>
            </div>
        </section>

        <section class="section bg-white pt-3">
            <div class="container">
                <div class="row mb-2">
                    <div class="col-8">
                        <div class="">
                            <router-link :to="{ name: 'Blog' }" class="text-primary"><i class="bx bx-left-arrow-alt"></i>
                                Kembali ke Blog </router-link>
                        </div>
                    </div>
                </div>
                <div v-if="blog == ''">
                    <div class="spinner-border text-primary" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
                <div class="row" v-if="blog != ''">
                    <div class="col-lg-8">
                        <div class="blog-box mb-4 mb-xl-0">
                            <div class="position-relative">
                                <img :src="blog.image" :alt="blog.slug" class="rounded img-fluid mx-auto d-block">
                            </div>
                            <div class="mt-4 text-muted">
                                <p class="mb-2"><i class="bx bx-calendar mr-1"></i> {{ blog.created_at }} </p>
                                <h5 class="mb-3">{{ blog.title }}</h5>
                                <div v-html="blog.description"></div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <h5 class="card-title mb-4">Postingan terbaru</h5>
                        <!-- loading if blogs no data -->
                        <div v-if="blogs == ''">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <div class="card blog-sidebar" v-for="item in blogs">
                            <div class="blog-box mb-4 mb-xl-0" @click="goDetail(item.slug)">
                                <div class="position-relative">
                                    <img :src="item.image" :alt="item.slug" class="rounded img-fluid mx-auto d-block">
                                </div>
                                <div class="mt-4 text-muted">
                                    <p class="mb-2"><i class="bx bx-calendar mr-1"></i> {{ item.created_at }}</p>
                                    <h5 class="mb-3">{{ item.title }}</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    name: 'BlogDetail',
    metaInfo() {
        return {
            title: this.blog.title,
            meta: [
                { name: 'description', content: this.blog.description },
                { name: 'keywords', content: this.blog.keywords },
                { name: 'author', content: this.blog.author },
                { name: 'og:title', content: this.blog.title },
                { name: 'og:description', content: this.blog.description },
                { name: 'og:image', content: this.blog.image },
                { name: 'og:url', content: this.blog.url },
                { name: 'og:type', content: 'website' },
                { name: 'og:site_name', content: 'Blog' },
            ]
        }
    },
    components: {
    },
    data() {
        return {
            blog: [],
            blogs: []
        }
    },
    methods: {
        async get_blog_detail(slug) {
            await axios({
                method: 'get',
                url: `/v1/get_blog_detail/${slug}`,
            }).then((response) => {
                this.blog = response.data
            })
            
        },
        get_blogs() {
            axios.get('v1/get_blogs', {
                params: {
                    limit: 5,
                    hide_description: false,
                    sort: 'DESC'
                }
            })
                .then((response) => {
                    this.blogs = response.data
                })
        },
        goDetail(slug) {
            this.$router.push({ name: 'BlogDetail', params: { slug: slug } })
        }
    },
    async mounted() {
        await this.get_blog_detail(this.$route.params.slug)
        document.title = this.blog.title
        this.$Progress.start()
        AOS.init({
            easing: 'ease-out-back',
            duration: 2000,
        });
        this.get_blogs()
        this.$Progress.finish()
    },
}
</script>